<template>
    <h2 class="heading">Personal Investment Form</h2>
    <div class="form">
        <el-form :model="investment" label-width="400px" style="width:1200px; margin-left:30px;" label-position="top" >
            <el-form-item label="Title" required>
                <el-input v-model="investment.title" minlength="2" maxlength="100" style="width:1050px" show-word-limit="true"/>
                <el-button style="margin-left:10px;" type="primary" @click="addNewItem" >
                    <el-icon><Plus/></el-icon> &nbsp; Add Item</el-button>
            </el-form-item>
            <el-form-item label="Items" required>
                <table class="details">
                    <tr>
                        <th>Action</th><th class="left">Name</th><th>Ticker</th><th>Market</th><th>Quantity</th>
                        <th>Trade Amount</th><th>Trade Date</th><th class="left">Attachment</th><th>Operation</th>
                    </tr>
                    <tr v-for="(item, index) in investment.detailList" :key="item.di">
                        <td class="center">{{item.type}}</td>
                        <td>{{item.name}}</td>
                        <td class="center">{{item.ticker}}</td>
                        <td class="center">{{item.market}}</td>
                        <td class="center">{{item.quantity}}</td>
                        <td class="center">{{item.tradeAmount}} {{item.currency}}</td>
                        <td class="center">{{item.tradeDate}}</td>
                        <td><a href="" @click.prevent="global.down(item.attachments.split(':')[0], item.attachments.split(':')[1])" 
                            v-if="item.attachments && item.attachments.length" target="_blank">
                            {{item.attachments.split(':')[1]}}</a></td>
                        <td class="center">
                            <el-icon :size="18" @click="editItem(index)" title="Edit" class="op">
                                <Edit />
                            </el-icon>
                            <el-icon :size="18" @click="investment.detailList.splice(index, 1)" title="Delete" class="op">
                                <Delete />
                            </el-icon>
                        </td>
                    </tr>
                </table>
            </el-form-item>
            <el-form-item label="Notes for trades approval">
                <div class="disclaimer">
                    <p><b>Capitalised terms used but not defined herein have the meanings set forth in the Compliance Manual 
                        (“Manual”).</b></p>
                    <p><b>Notes for trades approval</b></p>
                    <ul>
                        <li>Transactions on Personal Investments in personal securities accounts must be approved by the 
                            Compliance Officer in advance prior to execution. Please refer to the Manual for complete 
                            definition of Personal Investments. </li>
                        <li>Approvals are valid for two (2) business days on the day approval has been granted.  Accordingly, 
                            “good till cancelled” orders are prohibited.  If a trade is not executed by the close of the 
                            said two (2) business of the approval granted by the Compliance Officer, you are required to 
                            submit a new preclearance form.  It is each employee’s responsibility to comply with all 
                            provisions of the Manual.  Obtaining preclearance satisfies the preclearance requirements 
                            of the Manual, but does not imply compliance with the Manual.</li>
                        <li>Preclearance procedures apply to all employees and accounts in which the employees hold beneficial 
                            interests and accounts of any persons over whom the employee exercises control and influence.</li>
                        <li>Employees shall provide trade confirmation of executed trades to the Compliance Officer within 
                            1 week after receipt.  Executed trades are requested to be held at least 30 calendar days before 
                            they can be sold / liquidated, except for trades exempted under the Manual or unless prior 
                            written approval of the responsible officers of the Company or Compliance Officer is given for 
                            an earlier disposal.</li>
                    </ul>
                        
                    <p><b>General approval criteria for personal account transactions</b></p>
                        <ul>
                            <li>No pending orders for all of the funds (as reflected in Bloomberg POMS)</li>
                            <li>For sell transaction, holding period of the stock should be equal or more than 30 calendar days 
                                except as exempted in the Manual.</li>
                        </ul>
                        
                    <p><b>Specific guidelines for transactions by portfolio managers (PM, including backup PM), research analysts 
                        / personnel  (RP) and traders (TR)</b></p>
                        <ul>
                            <li>PM / RP/ TR shall not transact on Personal Investments within two (2) trading day before or 
                                after a recommendation or trading on the same investment is made or proposed or executed by him / her.*</li>
                            <li>PM / RP/ TR shall not participate in initial public offers available to clients of the Company 
                                or its connected persons, and shall not use his / her position to gain access to IPO for himself / 
                                herself or other person.</li>
                        </ul>
                    <p>
                        *this restriction can at the absolute discretion of the Compliance Officer be removed where client orders 
                        have been fully executed and if the subject PM / RP/ TR has confirmed there is no conflicts of interest or 
                        any conflict of interest has been removed.</p>
                        
                    <p><b>Prohibition of insider dealing</b></p>
                        <ul>
                            <li>Insider trading is a criminal offence in Hong Kong.  No director or employee may trade, either 
                                personally or on behalf of clients, on material non-public information or communicating material 
                                non-public information to others in violation of law. </li> 
                        </ul>
                        
                    <p><b>Declaration:</b></p>
                    <p>
                        The employee agrees that the subject order is in compliance with the Manual and is NOT based on knowledge 
                        of an actual client order within the previous seven calendar days in the Personal Investment that is being 
                        purchased or sold, or knowledge that the Personal Investment is being considered for purchase or sale in 
                        one or more specific client accounts, or knowledge of a change or pendency of a change of an investment 
                        management recommendation.  The employee also acknowledges that he or she is not in possession of material, 
                        inside information pertaining to the Personal Investment or issuer of the Personal Investment.
                    </p>
                </div>
            </el-form-item>
            <el-form-item label="" v-if="errMsg != ''">
                <div style="text-align:center;width:1200px;" class="errMsg">
                    {{errMsg}}
                </div>
            </el-form-item>
            <el-form-item label="">
                <div style="width:1200px; text-align:center; line-height:24px;">
                    <el-button type="primary" @click="saveInvestment" style="">Submit</el-button> &nbsp; 
                    <el-button @click="$router.push('/investment/myInvestmentList')">Cancel</el-button>
                    <span v-if="loading" style="padding-left:20px; vertical-align:bottom;">
                        <img src="@/assets/loading.gif" style="height:24px;"/>
                    </span>
                </div>
            </el-form-item>
        </el-form>
    </div>

    <el-dialog v-model="dialogFormVisible" title="Add / Edit Investment Item" width="660px" center>
        <el-form :model="item" label-width="130px" style="width:600px" >
            <el-form-item label="Trading type" required>
                <el-select v-model="item.type" placeholder="Trading action" style="width:200px;">
                    <el-option label="Buy" value="Buy" />
                    <el-option label="Sell" value="Sell" />
                </el-select>
            </el-form-item>
            <el-form-item label="Ticker" required>
                <el-autocomplete  v-model="item.ticker"
                    :fetch-suggestions="queryTicker"
                    :trigger-on-focus="false" clearable class="inline-input"
                    placeholder="Ticker of stock or ETF"
                    @select="selectItem"/>
            </el-form-item>
            <el-form-item label="Name" required>
                <el-autocomplete v-model="item.name" 
                    :fetch-suggestions="queryName"
                    :trigger-on-focus="false" clearable class="inline-input"
                    placeholder="Name of stock or ETF"
                    @select="selectItem"/>
            </el-form-item>
            <el-form-item label="Market" >
                <el-input type="text" v-model="item.market" placeholder="Trading market"/>
            </el-form-item>
            <el-form-item label="Number of shares">
                <el-input-number v-model="item.quantity" :min="0" :max="100000000" precision="0" style="width:200px;"/>
            </el-form-item>
            <el-form-item label="Trading amount" required>
                <el-input-number v-model="item.tradeAmount" :min="0" :max="100000000" precision="2" style="width:200px;"/>
                <el-select v-model="item.currency" placeholder="Currency" style="width:150px;margin-left:10px;">
                    <el-option label="HKD" value="HKD"/><el-option label="USD" value="USD"/><el-option label="RMB" value="RMB"/>
                    <el-option label="CNY" value="CNY"/><el-option label="EUR" value="EUR"/><el-option label="GBP" value="GBP"/>
                    <el-option label="SGP" value="SGP"/><el-option label="AUD" value="AUD"/><el-option label="CAD" value="CAD"/>
                    <el-option label="Others" value="N/A" />
                </el-select>
            </el-form-item>
            <el-form-item label="Trade date" required>
                <el-date-picker v-model="item.tradeDate" type="date" placeholder="Trade date" value-format="YYYY-MM-DD"/>
            </el-form-item>
            <el-form-item label="Attachment">
                <el-tag v-if="item.attachments && item.attachments.length" closable @close="removeFile()">
                    <a @click="global.down(item.attachments.split(':')[0], item.attachments.split(':')[1])">{{item.attachments.split(':')[1]}}</a>
                </el-tag>
                <el-upload :action="global.upload_path" :limit="1" 
                        :on-success="uploaded" :data="{'type':'investment'}" :show-file-list="false">
                    <el-button type="primary" plain>Browse</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item label="" v-if="errMsg != ''">
                <span class="errMsg" v-if="errMsg != ''">{{errMsg}}</span>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="addItem">Confirm</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script>
import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { Plus, Minus, Edit, Delete } from '@element-plus/icons-vue'
export default {
    components: {
        Plus, Minus, Edit, Delete
    },
    data() {
        return {
            investment: {
                title: null,
                detailList: [],
            },
            item: this.getItem(),
            currentUser: null,
            errMsg: '',
            dialogFormVisible: false,
            allSecurities: [],
            index: -1,
            loading: false,
            global,
        }
    },
    async created() {
        this.currentUser = this.global.currentUser;
        this.global.index = "investment";
    },
    async mounted() {
        this.allSecurities = this.getAllSecurities();
        let code = this.$route.query ? this.$route.query.code : null;
        if (code) {
            let result = await AXIOS("/investment/getInvestmentByCode", {code: code});
            if (result.success) {
                this.investment = result.data;
                for (let i = 0; i < this.investment.detailList.length; i++) {
                    let tradeAmount = this.investment.detailList[i].tradeAmount;
                    let regex = /[0-9\.]+ [A-Z]/;
                    if (regex.test(tradeAmount)) {
                        this.investment.detailList[i].tradeAmount = tradeAmount.split(" ")[0];
                        this.investment.detailList[i].currency = tradeAmount.split(" ")[1];
                    }
                }
            }
        }
    },
    methods: {
        async getAllSecurities() {
            let result = await AXIOS("/investment/getAllSecurities");
            if (result.success) {
                this.allSecurities = result.data;
            }
        },
        selectItem(item) {
            this.item.ticker = item.value.split(" - ")[0];
            this.item.name = item.value.split(" - ")[1];
            this.item.needApproval = false;
        },
        queryTicker(queryStr, callback) {
            queryStr = queryStr.toUpperCase();
            let result1 = [];
            let result2 = [];
            for (var i = 0; i < this.allSecurities.length; i++) {
                let item = this.allSecurities[i];
                if (item.value.startsWith(queryStr))
                    result1.push(item);
                else if (item.value.indexOf(queryStr) > -1)
                    result2.push(item);
            }
            return callback(result1.concat(result2));
        },
        queryName(queryStr, callback) {
            queryStr = queryStr.toLowerCase();
            let result1 = [];
            let result2 = [];
            for (var i = 0; i < this.allSecurities.length; i++) {
                let item = this.allSecurities[i];
                let value = item.value.toLowerCase();
                let name = value.substring(value.indexOf(" - ") + 3);
                if (name.startsWith(queryStr))
                    result1.push(item);
                else if (name.indexOf(queryStr) > -1)
                    result2.push(item);
            }
            return callback(result1.concat(result2));
        },
        editItem(index) {
            this.item = this.investment.detailList[index];
            this.index = index;
            this.dialogFormVisible = true;
        },
        addNewItem() {
            this.dialogFormVisible = true;
            this.errMsg = "";
            this.index = -1;
        },
        addItem() {
            this.errMsg = "";
            if (this.item.type == null) {
                this.errMsg = "Please choose 'Trading type'"; return;
            }
            if (this.item.ticker == null || this.item.ticker == '') {
                this.errMsg = "Please input 'Ticker'"; return;
            }
            if (this.item.name == null || this.item.name == '') {
                this.errMsg = "Please input 'Name'"; return;
            }
            if (this.item.quantity == null || this.item.quantity == 0) {
                this.errMsg = "Please input 'Number of shares'"; return;
            }
            if (this.item.tradeAmount == null || this.item.tradeAmount == 0) {
                this.errMsg = "Please input 'Trading amount'"; return;
            }
            if (this.item.currency == null) {
                this.errMsg = "Please choose 'Currency'"; return;
            }
            if (this.item.tradeDate == null) {
                this.errMsg = "Please select 'Trade date'"; return;
            }
            if (this.index == -1) {
                this.investment.detailList.push(this.item);
            } else {
                this.investment.detailList[this.index] = this.item;
                this.index = -1;
            }
            this.item = this.getItem();
            this.dialogFormVisible = false;
        },
        getItem() {
            return {
                type: null,
                name: null,
                ticker: null,
                market: null,
                quantity: null,
                tradeAmount: null,
                currency: null,
                tradeDate: null,
                attachments: null,
            }
        },
        uploaded(response, file, uploadFiles) {
            let resp = uploadFiles[0].response[0];
            if (resp) {
                this.item.attachments = resp.url + ":" + resp.name; 
            }
            uploadFiles.splice(0, uploadFiles.length);
        },
        removeFile() {
            this.item.attachments = null;
        },
        async saveInvestment() {
            this.errMsg = ""
            if (this.investment.title == null || this.investment.title == '') {
                this.errMsg = "Please input [title]";
                return;
            }
            if (this.investment.detailList.length == 0) {
                this.errMsg = "Please add [Invest Item]";
                return;
            }
            if (this.loading) return; // avoid repeat submit
            this.loading = true;
            this.investment["items"] = JSON.stringify(this.investment.detailList);
            let result = await AXIOS("/investment/saveInvestment", this.investment);
            if (result.success) {
                this.$router.push("/investment/myInvestmentList");
            }
        }
    }
}
</script>

<style scoped>
    .heading { width:1300px; }
    .disclaimer {height:320px;overflow-y:scroll; padding:10px; border:1px solid #ccc; line-height:1.5em; color:#555;}
    .disclaimer li {margin-top:6px; margin-bottom:6px;}
    .disclaimer p {margin:6px;}
    .item th {color:#888; text-align:left;}
    .item {width:100%; margin-top:-3px;}
    .item .el-icon {color:#007dff; cursor: pointer;}
    .details { width:100%; border: 1px solid #ddd; border-collapse: collapse;}
    .details th {background:#f5f5f5; border-bottom: 1px solid #ddd; color:#555;}
    .details td {border-bottom: 1px solid #ddd;}

    .el-tag a {cursor: pointer; }
</style>